import styled from 'styled-components';
import { SearchBarStyle } from '../../../../styles/common';
import theme from '../../../../styles/theme';
import CommonDataGrid from '../../../common/CommonDataGrid';
import FullModal from '../../../common/modal/FullModal';
import moment from 'moment';
import { useGetInoutSel } from '../../../../interface/inout';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControl, Select, InputLabel, TextField, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import Button from '../../../common/Button';
import { useGetCodeList } from '../../../../interface/common';
import InoutItem from './InoutItem';
import { IOT_TP, USER_TP } from '../../../common/constants';
import { availCheck } from './common';
import { useQuery } from 'react-query';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        // display: inline-box;
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        // width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
    div {
        // width: calc(100% - 24px);
        // padding: 12px;
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'iot_nm', headerName: '과업명', flex: 1.5 },
    { field: 'cnm', headerName: '거래처', flex: 1 },
    { field: 'work_nm', headerName: '작업자', flex: 0.5 },
    { field: 'iot_tpnm', headerName: '반출입유형', flex: 0.5 },
    { field: 'sub_tpnm', headerName: '유형', flex: 1 },
    { field: 'is_ing_nm', headerName: '진행상태', flex: 0.5 },
    { field: 'contents', headerName: '내용', flex: 2 },
    { field: 'reg_dt', headerName: '등록일', flex: 1 },
    { field: 'reg_nm', headerName: '등록자', flex: 1},


]

const InoutMain = () => {

    const navigate = useNavigate();

    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const [sendParam, setSendParam] = useState((!user || user.user_tp === USER_TP.USER) ? {iot_tp:IOT_TP.SEARCH}:{});
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();
    const [list, setList] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const [isIng, setIsIng] = useState('1');

    const {data : iotTpList} = useGetCodeList('iot_tp');

    const {data, isError, isLoading, refetch } = useGetInoutSel(sendParam);

    useEffect(()=>{
        if(data){
            setList(data.map((item,index)=>({
                                    ...item,
                                    is_ing_nm: item.is_ing === 1 ? '진행중' : '완료',
                                    reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm'),
                                    id:index
                                })));
        }else{
            setList([])
        }
    },[data])

    useEffect(()=>{
        if(list && list.length > 0){
            const temp = isIng === 'A' ? list : list.filter((item)=>(item.is_ing+'') === isIng);
            setFilterList(temp)
        }else{
            setFilterList([])
        }
    },[list, isIng])

    const handleValueChange = (id, val) => {
        setSendParam({...sendParam,[id]:val});
    }

    const goSearch = () => {
        refetch();
    }

    return (
        <MainWrap>
            <h3>반출입</h3>
            <div>
                <SearchBarStyle>
                    <div style={{display:'flex',gap: '1rem',flexWrap:'wrap', justifyContent:'flex-start', alignItems:'center'}}>
                        {availCheck(user.user_tp) ?
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='iotTp-label'>반출입유형</InputLabel>
                            <Select label="반출입유형" labelId='iotTp-label' size='small'>
                                <MenuItem value={''} onClick={()=>handleValueChange('iot_tp','')} >없음</MenuItem>
                                {iotTpList && iotTpList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('iot_tp',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        :
                        <TextField
                            id='iot_tpnm'
                            label='반출입유형'
                            size='small'
                            value='조사설치'
                            // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            disabled
                        />
                        }
                        <TextField 
                            id='sdate'
                            label='등록일(From)' 
                            style={{width:'10rem'}} 
                            InputLabelProps={{shrink:true}} 
                            type='date' 
                            size='small' 
                            onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                        />
                        ~
                        <TextField 
                            id='edate'
                            label='등록일(To)' 
                            style={{width:'10rem'}} 
                            InputLabelProps={{shrink:true}} 
                            type='date' 
                            size='small' 
                            onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                        />
                        {/* <FormControl style={{width:'8rem'}} size='small'>
                            <InputLabel id='isIng-label'>작업상태</InputLabel>
                            <Select label="작업상태" labelId='isIng-label' size='small'>
                                <MenuItem 
                                    value={-1} 
                                    onClick={()=>handleValueChange('is_ing',-1)}
                                >
                                    전체
                                </MenuItem>
                                <MenuItem 
                                    value={1} 
                                    onClick={()=>handleValueChange('is_ing',1)}
                                >
                                    진행중
                                </MenuItem>
                                <MenuItem 
                                    value={0} 
                                    onClick={()=>handleValueChange('is_ing',0)}
                                >
                                    완료
                                </MenuItem>
                            </Select>
                        </FormControl> */}
                    </div>
                    <div style={{display:'flex',gap: '1rem',flexWrap:'wrap', justifyContent:'flex-end', alignItems:'center'}}>
                        <Button onClick={goSearch} style={{width:'120px'}}>검색</Button>
                        {availCheck(user.user_tp) && <Button onClick={()=>{setTarget();setRegOpen(true)}} style={{width:'120px'}}>등록</Button>}
                    </div>
                </SearchBarStyle>
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="is_ing-label"
                        defaultValue={1}
                        name="is_ing"
                        onChange={(e)=>setIsIng(e.target.value)}
                    >
                        <FormControlLabel value={"A"} control={<Radio />} label="전체" />
                        <FormControlLabel value={1} control={<Radio />} label="진행중" />
                        <FormControlLabel value={0} control={<Radio />} label="완료" />
                    </RadioGroup>
                </FormControl>
            </div>
            <div style={{width:'100%', height: '72vh'}}>
            <CommonDataGrid
                isLoading={isLoading}
                list={filterList}
                columns={columns}
                onRowClick={(e)=>{navigate('/admin/inout/'+e.row.sno+'/inoutDetail')}}
                // onRowClick={(e)=>{{setTarget(e.row);setRegOpen(true)}}}
                />
                </div>
            <FullModal open={regOpen}>
                <DetailWrap onClose={setRegOpen}/>
            </FullModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

export const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <InoutItem target={target} onClose={onClose} />
        </DetailWrapStyle>
    )
}

export default InoutMain;